export default __webpack_public_path__ + "static/media/Denil.513083fc.jpg";